import { Link } from "react-router";
import { useDocumentTitle } from "@/lib/document-title";

export function NotFound() {
  useDocumentTitle("Not found");

  return (
    <main className="flex min-h-screen items-center justify-center px-6">
      <div className="text-center">
        <p className="eyebrow">404</p>
        <h1 className="mt-2 text-lg font-semibold text-ink">That page does not exist</h1>
        <p className="mt-1 text-sm text-ink-muted">
          The case or borrower may have been closed.
        </p>
        <Link
          to="/inbox"
          className="mt-4 inline-block rounded-md bg-accent px-3 py-1.5 text-sm font-medium text-white"
        >
          Back to inbox
        </Link>
      </div>
    </main>
  );
}
